<template>
    <div class="pt-5 d-flex justify-content-center" v-if="changelog">
        <b-card class="p-3 w-100" style="max-width: 768px;">
            <div v-html="changelog"></div>
        </b-card>
    </div>
</template>

<script lang="js">
import MarkdownIt from 'markdown-it'
const md = MarkdownIt()
import axios from "axios";
export default {
    data(){
        return {
            changelog: '',
        }
    },
    beforeCreate() {
        axios.get('/changelog').then(resp => {
            this.changelog = md.render(resp.data.changelog)
        })
    }
}
</script>
